<template>
  <section>
    <div class="d-flex align-items-center">
      <label class="tx-uppercase tx-10 tx-medium tx-spacing-1 tx-color-03"
        >Календар</label
      >
      <label class="tx-10 tx-medium tx-spacing-1 tx-color-01 mg-l-auto">{{
        value1 | moment("YYYY оны MM-р сар")
      }}</label>
    </div>
    <DatePicker
      v-model="value1"
      @change="fetchData"
      type="month"
      size="mini"
      placeholder="Сонгоно уу"
      class="mg-l-auto"
      style="width: 100%"
    ></DatePicker>

    <!-- {{calendarData}} -->
    <div v-for="(c, i) in calendarBox" :key="i" class="bd-t mg-t-10">
      <main class="calendar">
        <div class="text-muted">Ня</div>
        <div class="font-weight-bold">Да</div>
        <div class="font-weight-bold">Мя</div>
        <div class="font-weight-bold">Лх</div>
        <div class="font-weight-bold">Пү</div>
        <div class="font-weight-bold">Ба</div>
        <div class="text-muted">Бя</div>

        <div
          v-for="(day, index) in c.days"
          :key="index"
          :style="{ gridColumn: column(index, i) }"
          :class="{ 'bg-secondary lms-calendar-today tx-white': today(day) }"
        >
          {{ day.format("D") }}
          <div
            v-show="getDayHas(day)"
            :class="
              `wd-10 ht-10 rounded-circle mb-n4 ml-n2 bg-${getDayColor(day)}`
            "
          ></div>
        </div>
      </main>
    </div>
    <div class="mg-t-20">
      <!-- <div v-if="$store.state.app.activeGroup.id==9241 || $store.state.app.activeGroup.id==9249" class="schedule-group">
        <router-link :to="getRoute(cal)" v-for="(cal,i) in calendarData" :key="i" href="#" :class="`schedule-item bd-l bd-2 bd-${cal.color}`" >
          <h6 v-if="cal.type==1" class="d-flex align-items-center">
            <feather :size="16" type="video" class="wd-20-f ht-20-f pd-r-20 mg-r-10"></feather>
            <span class="tx-13">{{cal.task.task}}</span>
          </h6>
          <h6 v-else-if="cal.type==2" class="d-flex align-items-center">
            <feather :size="16" type="pen-tool" class="wd-20-f ht-20-f pd-r-20 mg-r-10"></feather>
            {{cal.form.name}}
          </h6>
          <span>{{cal.calendarDate | moment('YYYY.MM.DD HH:mm, dddd')}}<br /> {{cal.course.name}}</span>
        </router-link>
      </div>-->

      <div class="card card-widget card-events bd-0" style="box-shadow: none">
        <ul class="list-unstyled media-list mg-b-0">
          <li
            @click="cal.hasLink ? $router.push(getRoute(cal)) : ''"
            class="media mg-b-20"
            v-for="(cal, i) in calendarData"
            :key="i"
            role="button"
          >
            <!-- {{cal}} -->
            <div class="media-left text-center">
              <div>
                <!-- <feather
                  v-else-if="cal.type==1"
                  type="pen-tool"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather> -->
                <!-- <feather v-if="cal.type==3" type="wifi" class="text-danger wd-25-f ht-25-f"></feather> -->
                <img
                  v-if="cal.type == 3"
                  src="https://res.gosmart.mn/media/gif/live.gif"
                  class="wd-40"
                />
                <img
                  v-else-if="cal.type == 1"
                  src="https://res.gosmart.mn/media/gif/live.gif"
                  class="wd-40"
                />
                <feather
                  v-else-if="cal.type == 4"
                  type="credit-card"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather>
                <feather
                  v-else
                  type="calendar"
                  class="tx-color-03 wd-25-f ht-25-f"
                ></feather>
              </div>
              <!-- <label>{{cal.calendarDate | moment('dddd')}}</label> -->
              <label>{{ cal.calendarDate | moment("MM/DD") }}</label>
              <p style="min-width: 45px; font-size: 16px !important">
                {{ cal.calendarDate | moment("HH:mm") }}
              </p>
              <!-- <div class="mg-t-5">{{cal.calendarDate | moment('MM/DD')}}</div> -->
            </div>
            <div class="media-body event-panel-green">
              <span
                v-if="cal.type == 1 || cal.type == 2 || cal.type == 3"
                class="event-time"
                >{{ cal.course.name }}</span
              >
              <span v-else class="event-time">{{ cal.desc }}</span>
              <router-link :to="cal.hasLink ? getRoute(cal) : ''">
                <h6 v-if="cal.type == 1 || cal.type == 3" class="event-title">
                  {{ cal.task.task }}
                </h6>
                <h6 v-else-if="cal.type == 2" class="event-title">
                  {{ cal.form.name }}
                </h6>
                <h6 v-else class="event-title">{{ cal.title }}</h6>
              </router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
const moment = require("moment");
import { DatePicker } from "element-ui";

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      value1: "",
      calendarBox: [],
      monthStart: 0,

      logData: {
        inTime: "",
        liog: [],
        months: [],
        outTime: ""
      },
      calendarData: []
    };
  },
  mounted() {
    require("@/assets/scss/pages/calendar.scss");
    this.value1 = new Date();
    this.fetchData();
    //this.init();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getRoute(cal) {
      let rv = "";
      if (cal.type == 1) {
        ///lms/courseView/:id/:bid/:iid/:bot
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/${cal.task.id}/${cal.box.objectTypeId}`;
      } else if (cal.type == 2) {
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/0/${cal.box.objectTypeId}`;
      } else if (cal.type == 3) {
        rv = `/lms/courseView/${cal.course.id}/${cal.box.id}/${cal.task.id}/${cal.box.objectTypeId}`;
      } else {
        rv = cal.rawUrl;
      }
      return rv;
    },
    getDayHas(day) {
      return hasOneOf(
        this.calendarData.map(e => {
          return moment(e.calendarDate).format("YYYY.MM.DD");
        }),
        [moment(day).format("YYYY.MM.DD")]
      );
    },
    getDayColor(day) {
      let rv = "";
      let _dd = this.calendarData.filter(
        x =>
          moment(x.calendarDate).format("YYYY.MM.DD") ==
          moment(day).format("YYYY.MM.DD")
      );
      if (_dd.length) {
        rv = _dd[0].color;
      }
      return rv;
    },
    fetchData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "v2/Learn/GetStudentCalendarData" },
        params: {
          year: moment(this.value1).format("YYYY"),
          month: moment(this.value1).format("MM"),
          future: true
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.calendarData = res.data.list;
          this.init();
        }
      });
    },
    init() {
      let self = this;
      self.calendarBox = [];
      for (var i = self.monthStart; i < self.monthStart + 1; i++) {
        //let md = moment(new Date().setMonth(new Date().getMonth() + i)).startOf("month");
        let md = moment(self.value1)
          .add(i, "month")
          .startOf("month");
        //console.log(formatDateYM(md, 'оны ')+'-р сар');
        //console.log(md)

        self.calendarBox.push({
          title: md,
          days: [...Array(md.daysInMonth())].map((_, i) =>
            md.clone().add(i, "day")
          )
        });
      }
    },
    column(index, i) {
      if (index == 0) {
        return this.calendarBox[i].days[0].day() + 1;
      }
    },
    today(day) {
      return moment().isSame(day, "day");
    },
    getTime(flag, date) {
      let rv = "";
      let rrr = "";
      if (this.logData.log != undefined && this.logData.log.length > 0) {
        rrr = this.logData.log[0].logTime.filter(
          x =>
            x.time != null &&
            x.flag == flag &&
            moment(x.time, "YYYY/MM/DD").isSame(moment(date, "YYYY/MM/DD"))
        );
        if (rrr.length > 0) {
          if (rrr[0].type == null || rrr[0].type == "")
            rv = rrr[0].timeSpan.substring(0, 5);
          else if (flag == 2) rv = rrr[0].type;
        }
      }
      return rv;
    }
  },
  computed: {
    dots() {
      return [
        {
          dot: "red",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 1),
            new Date(this.thisMonthYear, this.thisMonth, 10),
            new Date(this.thisMonthYear, this.thisMonth, 22),
            new Date(this.nextMonthYear, this.nextMonth, 6),
            new Date(this.nextMonthYear, this.nextMonth, 16)
          ]
        },
        {
          dot: "teal",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 4),
            new Date(this.thisMonthYear, this.thisMonth, 10),
            new Date(this.thisMonthYear, this.thisMonth, 15),
            new Date(this.nextMonthYear, this.nextMonth, 1),
            new Date(this.nextMonthYear, this.nextMonth, 12),
            {
              start: new Date(this.nextMonthYear, this.nextMonth, 20),
              end: new Date(this.nextMonthYear, this.nextMonth, 25)
            }
          ]
        },
        {
          dot: "blue",
          dates: [
            new Date(this.thisMonthYear, this.thisMonth, 12),
            new Date(this.thisMonthYear, this.thisMonth, 26),
            new Date(this.thisMonthYear, this.thisMonth, 15),
            new Date(this.nextMonthYear, this.nextMonth, 9),
            new Date(this.nextMonthYear, this.nextMonth, 5),
            new Date(this.nextMonthYear, this.nextMonth, 6),
            new Date(this.nextMonthYear, this.nextMonth, 20),
            new Date(this.nextMonthYear, this.nextMonth, 25)
          ]
        }
      ];
    }
  }
};
</script>

<style scoped>
.m-calendar {
  background: #fff;
  padding: 0;
}
.calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  max-width: 100vw;
  width: 100%;
}

.calendar > * {
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  height: 35px;
}

.calendar > *::before {
  content: "";
  display: inline-block;
  height: 0;
  padding-bottom: 100%;
  width: 1px;
}

.calendar > *.today {
  background-color: hsl(241deg 100% 79%) !important;
  color: white;
  /* border: 0.1em solid rgba(0, 0, 0, 0.2); */
  border-radius: 100%;
}

.calendar > *.active {
  border-radius: 100%;
  background: rgb(43, 175, 180);
  color: #fff;
}
</style>
